import { render, staticRenderFns } from "./ScoreList.vue?vue&type=template&id=c88b6888&scoped=true&"
import script from "./ScoreList.vue?vue&type=script&lang=js&"
export * from "./ScoreList.vue?vue&type=script&lang=js&"
import style0 from "./ScoreList.vue?vue&type=style&index=0&id=c88b6888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88b6888",
  null
  
)

export default component.exports